(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sg-background-video"] && !Shopify.designMode) return;
  try {
    (() => {
    const records = new Map();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function sync(video, state) {
      video.controls = reducedMotion.matches || state.playFailed;
      if (!state.visible || document.hidden || reducedMotion.matches) {
        video.pause();
        return;
      }
      const request = video.play();
      if (request) request.catch(() => {
        state.playFailed = true;
        video.controls = true;
      });
    }

    function scan(scope) {
      scope.querySelectorAll('video[data-sg-background-video]').forEach(video => {
        if (records.has(video) || !('IntersectionObserver' in window)) return;
        const state = { visible: false, playFailed: false };
        video.muted = true;
        video.controls = reducedMotion.matches;
        state.observer = new IntersectionObserver(entries => {
          state.visible = entries[0].isIntersecting;
          sync(video, state);
        }, { threshold: 0.1 });
        records.set(video, state);
        state.observer.observe(video);
      });
    }

    function syncAll() {
      records.forEach((state, video) => sync(video, state));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
    } else {
      scan(document);
    }
    document.addEventListener('visibilitychange', syncAll);
    reducedMotion.addEventListener('change', syncAll);
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      records.forEach((state, video) => {
        if (!event.target.contains(video)) return;
        state.observer.disconnect();
        video.pause();
        records.delete(video);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
